<template>
    <group-details :groupId="props.groupId">
        <div class="col-span-12 lg:col-span-10">
            <page-loading v-if="!group"></page-loading>
            <template v-else>
                <group-proforma-invoices
                    v-if="group.is_billable && typeof group.payment_terms_days === 'number'"
                    :team-id="props.teamId"
                    :group-id="group.group_id"
                    :payment-terms-days="group.payment_terms_days"
                />
            </template>
        </div>
    </group-details>
</template>

<script setup>
import GroupProformaInvoices from '~/components/settings/billing/GroupProformaInvoices.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import GroupDetails from '../form/GroupDetails.vue';
import { ref, onMounted, watch } from 'vue';
import { groupsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});

const group = ref(null);
const toasted = useToasted();

const getGroup = async () => {
    try {
        const response = await groupsClient.getGroup({ teamId: props.teamId }, props.groupId);
        group.value = response.data;
    } catch (error) {
        console.error('Failed to fetch group:', error);
        toasted.error('Failed to load group details. Please try again.');
    }
};

onMounted(() => {
    getGroup();
});

watch(
    () => [props.teamId, props.groupId],
    () => {
        getGroup();
    },
);
</script>
